import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { CTAButton } from '../ui/CTAButton';
import { Timer, Smartphone, Infinity, BookOpen } from 'lucide-react';
export function Offer() {
  return <section id="oferta" className="py-24 bg-white scroll-mt-10" data-id="element-86">
      <div className="container mx-auto px-4 max-w-3xl" data-id="element-87">
        <FadeIn data-id="element-88">
          <div className="border-4 border-gold rounded-3xl p-8 md:p-12 text-center relative shadow-2xl" data-id="element-89">
            {/* Urgency Badge */}
            <div className="absolute -top-6 left-1/2 transform -translate-x-1/2 bg-navy text-white px-6 py-2 rounded-full font-bold flex items-center gap-2 shadow-lg w-max text-sm md:text-base" data-id="element-90">
              <Timer className="w-5 h-5 text-gold" data-id="element-91" />
              OFERTA POR TIEMPO LIMITADO
            </div>

            <h2 className="text-3xl md:text-4xl font-bold text-navy mb-8 mt-4" data-id="element-92">
              Empezá tu viaje musical hoy
            </h2>

            <div className="mb-8" data-id="element-93">
              <p className="text-xl text-navy/60 line-through mb-2" data-id="element-94">
                Precio normal: AR$ 49.990
              </p>
              <div className="flex items-center justify-center gap-4" data-id="element-95">
                <span className="text-5xl md:text-6xl font-bold text-navy" data-id="element-96">
                  AR$ 19.990
                </span>
              </div>
              <p className="text-green-600 font-bold mt-4 text-lg" data-id="element-97">
                ¡Ahorrás AR$ 30.000!
              </p>
            </div>

            {/* Value reinforcements */}
            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8 text-sm text-navy/70" data-id="element-98">
              <div className="flex items-center gap-2" data-id="element-99">
                <Infinity className="w-4 h-4 text-gold" data-id="element-100" />
                <span data-id="element-101">Acceso completo de por vida</span>
              </div>
              <div className="hidden sm:block w-1 h-1 rounded-full bg-navy/30" data-id="element-102"></div>
              <div className="flex items-center gap-2" data-id="element-103">
                <BookOpen className="w-4 h-4 text-gold" data-id="element-104" />
                <span data-id="element-105">Todo en un solo método paso a paso</span>
              </div>
            </div>

            <a href="https://checkout.tusbeneficios.shop/cart/50965915992297:1" target="_blank" rel="noopener noreferrer" className="inline-flex items-center justify-center w-full bg-gold hover:bg-gold-hover text-white font-bold text-xl py-5 px-8 rounded-full transition-all duration-300 transform hover:scale-105 hover:shadow-lg mb-6" data-id="element-106">
              QUIERO TOCAR MI PRIMERA CANCIÓN
            </a>

            <div className="flex flex-col items-center gap-1 text-navy/70 font-medium" data-id="element-107">
              <div className="flex items-center gap-2" data-id="element-108">
                <Smartphone className="w-5 h-5" data-id="element-109" />
                <p data-id="element-110">Acceso inmediato desde cualquier dispositivo</p>
              </div>
              <p className="text-sm text-navy/50" data-id="element-111">Empezás hoy mismo</p>
            </div>
          </div>
        </FadeIn>
      </div>
    </section>;
}